(() => {
  'use strict';

  const initCollectionRepair = () => {
    const root = document.querySelector('.r32-ui.r32-collection');
    if (!root) return;

    const isSpanish = String(document.documentElement.lang || '')
      .toLowerCase()
      .startsWith('es');

    // This inline style was historically embedded in one collection body.
    // The dedicated stability asset now owns those rules.
    document.querySelectorAll('style#mm-live-card-hotfix').forEach((node) => node.remove());

    const recovery = document.querySelector('[data-mm-empty-recovery]');
    if (recovery) {
      const originalEmpty = root.querySelector('#R32ProductGrid.r32-empty, .r32-empty#R32ProductGrid');
      if (originalEmpty && !originalEmpty.contains(recovery)) {
        originalEmpty.hidden = true;
        originalEmpty.setAttribute('aria-hidden', 'true');
      }
    }

    const filterForm = root.querySelector('.r32-filter form');
    const filterToggle = root.querySelector('.r32-filter-mobile-toggle, .r32-filter-toggle');

    const getActiveFilterCount = () => {
      if (!filterForm) return 0;

      const checkedValues = filterForm.querySelectorAll(
        'input[type="checkbox"]:checked, input[type="radio"]:checked'
      ).length;

      const priceValues = Array.from(
        filterForm.querySelectorAll('input[type="number"], input[name*="filter.v.price"]')
      ).some((input) => String(input.value || '').trim() !== '') ? 1 : 0;

      const selectedMenus = Array.from(filterForm.querySelectorAll('select')).filter(
        (select) => select.value && select.selectedIndex > 0
      ).length;

      return checkedValues + priceValues + selectedMenus;
    };

    const updateFilterCount = () => {
      if (!filterToggle) return;

      const count = getActiveFilterCount();
      let badge = filterToggle.querySelector('.mm-active-filter-count');

      if (count < 1) {
        if (badge) badge.remove();
        filterToggle.removeAttribute('data-active-filter-count');
        return;
      }

      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'mm-active-filter-count';
        badge.setAttribute('aria-label', isSpanish ? 'Filtros activos' : 'Active filters');
        filterToggle.appendChild(badge);
      }

      badge.textContent = String(count);
      filterToggle.setAttribute('data-active-filter-count', String(count));
    };

    if (filterForm) {
      filterForm.addEventListener('change', updateFilterCount);
      filterForm.addEventListener('input', updateFilterCount);
    }
    updateFilterCount();

    root.querySelectorAll('.r32-sort select, select[data-mm-sort]').forEach((select) => {
      if (!select.getAttribute('aria-label') && !select.getAttribute('aria-labelledby')) {
        select.setAttribute('aria-label', isSpanish ? 'Ordenar productos' : 'Sort products');
      }
    });

    const resultCount = root.querySelector(
      '.r32-count, .r32-results-count, [data-r32-count], .r32-catalog-top > strong'
    );
    if (resultCount && !resultCount.hasAttribute('aria-live')) {
      resultCount.setAttribute('role', 'status');
      resultCount.setAttribute('aria-live', 'polite');
      resultCount.setAttribute('aria-atomic', 'true');
    }

    if (filterToggle && !filterToggle.getAttribute('aria-controls')) {
      const target = filterToggle.getAttribute('data-target');
      if (target) filterToggle.setAttribute('aria-controls', target.replace(/^#/, ''));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionRepair, { once: true });
  } else {
    initCollectionRepair();
  }
})();
